import { Globe } from "@ews-admin/global-design-system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchSpecialtiesRequest } from "../../../store/reducers/specialtySlice";
import { updateAppLanguage } from "../../../webclients/user.client";

const languages = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const dispatch = useAppDispatch();
  const userId = useAppSelector(state => state.session.session?.user?.id);
  // Find current language index
  useEffect(() => {
    const currentLangIndex = languages.findIndex(
      lang => lang.code === i18n.language
    );
    if (currentLangIndex !== -1) {
      setCurrentIndex(currentLangIndex);
    }
  }, [i18n.language]);

  const nextLanguage = languages[(currentIndex + 1) % languages.length];

  const handleLanguageSwitch = async () => {
    try {
      const nextIndex = (currentIndex + 1) % languages.length;
      const nextLanguage = languages[nextIndex];
      setCurrentIndex(nextIndex);
      await i18n.changeLanguage(nextLanguage.code);
      dispatch(fetchSpecialtiesRequest({ lang: nextLanguage.code }));
      // Persist for emails sent without a request (reminders, doctor copies).
      // Fire-and-forget: a failure here must not block the UI switch.
      if (userId) {
        updateAppLanguage(userId, nextLanguage.code).catch(() => undefined);
      }
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  return (
    <button
      onClick={handleLanguageSwitch}
      className="flex items-center px-3 py-2 space-x-3 w-full text-sm rounded-lg transition-colors text-neutral-700 hover:bg-neutral-50 hover:text-neutral-900"
      aria-label={`Switch to ${nextLanguage.name}`}
      title={`Switch to ${nextLanguage.name}`}
    >
      <Globe className="w-5 h-5 text-neutral-500" />
      <span className="font-medium">{nextLanguage.name}</span>
    </button>
  );
};
